import { CRITICALITY_LEVELS } from "routes/schedule/plugins/legislation-resolutions/criticality-config"

export function buildRecommendationCriticalityMeta(recommendation = {}) {
    const criticality = `${recommendation?.criticality || ""}`.toLowerCase()
    if (!criticality) return null

    const config = CRITICALITY_LEVELS[criticality]
    if (!config) return null

    return {
        criticality,
        label: config.label,
        icon: config.icon,
        color: config.color,
    }
}
